/**
 * Mental health roles.
 */
export const mentalHealthRoleOptionsUs = [
  {value: 'counsellor', label: 'Counsellor'},
  {value: 'psychiatrist', label: 'Psychiatrist'},
  {value: 'psychologist', label: 'Psychologist'},
  {
    value: 'registered Psychotherapist',
    label: 'Registered Psychotherapist',
  },
  {
    value: 'social Work/Therapist',
    label: 'Social Work/Therapist',
  },
  {value: 'Other', label: 'Other'},
];

export const mentalHealthRoleOptionsSpain = [
  {value: 'Terapeuta', label: 'Terapeuta'},
  {value: 'Psicoterapeuta', label: 'Psicoterapeuta'},
  {value: 'Psicólogo', label: 'Psicólogo'},
  {value: 'Psiquiatra', label: 'Psiquiatra'},
  {value: 'Other', label: 'Otro'},
];

export const mentalHealthRoleOptionsPtBr = [
  {value: 'conselheiro', label: 'Conselheiro'},
  {value: 'psiquiatra', label: 'Psiquiatra'},
  {value: 'psicólogo', label: 'Psicólogo'},
  {
    value: 'psicoterapeuta registrado',
    label: 'Psicoterapeuta Registrado',
  },
  {
    value: 'assistente social/terapeuta',
    label: 'Assistente Social/Terapeuta',
  },
  {value: 'outro', label: 'Outro'},
];

export const mentalHealthRoleOptionsByCountry = {
  US: mentalHealthRoleOptionsUs,
  ES: mentalHealthRoleOptionsSpain,
  MX: mentalHealthRoleOptionsSpain,
  PT: mentalHealthRoleOptionsSpain,
  BR: mentalHealthRoleOptionsPtBr,
};

/**
 * Academic initials.
 */
export const academicInitialsOptionsUs = [
  {label: 'MA', value: 'MA'},
  {label: 'MC', value: 'MC'},
  {label: 'MSc', value: 'MSc'},
  {label: 'PhD', value: 'PhD'},
  {label: 'MBBS', value: 'MBBS'},
  {label: 'PsychD', value: 'PsychD'},
  {label: 'Other', value: 'Other'},
];

export const academicInitialsOptionsSpain = [
  {value: 'Dr. en Psicología', label: 'Dr. en Psicología'},
  {value: 'Lic. Filosofía', label: 'Lic. Filosofía'},
  {value: 'Lic. Medicina', label: 'Lic. Medicina'},
  {value: 'Lic. en Psicología', label: 'Lic. en Psicología'},
  {value: 'MRes', label: 'MRes'},
  {value: 'Maestría', label: 'Maestría'},
  {value: 'MSc', label: 'MSc'},
  {value: 'PhD', label: 'PhD'},
  {value: 'Other', label: 'Otro'},
];

export const academicInitialsOptionsPtBr = [
  {label: 'MA', value: 'MA'},
  {label: 'MC', value: 'MC'},
  {label: 'MSc', value: 'MSc'},
  {label: 'PhD', value: 'PhD'},
  {label: 'MBBS', value: 'MBBS'},
  {label: 'PsychD', value: 'PsychD'},
  {label: 'Outro', value: 'Outro'},
];

export const academicInitialsOptionsByCountry = {
  US: academicInitialsOptionsUs,
  ES: academicInitialsOptionsSpain,
  MX: academicInitialsOptionsSpain,
  PT: academicInitialsOptionsSpain,
  BR: academicInitialsOptionsPtBr,
};

/**
 * Title options.
 */
export const titleOptionsUs = [
  {label: 'Dr', value: 'Dr'},
  {label: 'Mr', value: 'Mr'},
  {label: 'Mrs', value: 'Mrs'},
  {label: 'Miss', value: 'Miss'},
  {label: 'Ms', value: 'Ms'},
  {label: 'Mx', value: 'Mx'},
  {label: 'Prof', value: 'Prof'},
  {label: 'Rev', value: 'Rev'},
  {label: 'Rev Dr', value: 'Rev Dr'},
  {label: 'Rabbi', value: 'Rabbi'},
  {label: 'Sister', value: 'Sister'},
];

export const titleOptionsSpain = [
  {value: 'Dr.', label: 'Dr.'},
  {value: 'Dra.', label: 'Dra.'},
  {value: 'Dres.', label: 'Dres.'},
  {value: 'Sr.', label: 'Sr.'},
  {value: 'Sra.', label: 'Sra.'},
  {value: 'Srta.', label: 'Srta.'},
  {value: 'Prof.', label: 'Prof.'},
  {value: 'Profa.', label: 'Profa.'},
  {value: 'Rdo.', label: 'Rdo.'},
  {value: 'Rda.', label: 'Rda.'},
  {value: 'Rabino', label: 'Rabino'},
  {value: 'Hna.', label: 'Hna.'},
];

export const titleOptionsPtBr = [
  {label: 'Dr', value: 'Dr'},
  {label: 'Sr', value: 'Sr'},
  {label: 'Sra', value: 'Sra'},
  {label: 'Srta', value: 'Srta'},
  {label: 'Sra', value: 'Sra'},
  {label: 'Mx', value: 'Mx'},
  {label: 'Prof', value: 'Prof'},
  {label: 'Rev', value: 'Rev'},
  {label: 'Rev Dr', value: 'Rev Dr'},
  {label: 'Rabino', value: 'Rabino'},
  {label: 'Irmã', value: 'Irmã'},
];

export const titleOptionsByCountry = {
  US: titleOptionsUs,
  ES: titleOptionsSpain,
  MX: titleOptionsSpain,
  PT: titleOptionsSpain,
  BR: titleOptionsPtBr,
};

/**
 * Credential type options.
 */
export const credentialTypeOptionsUs = [
  {value: 'membership', label: 'Membership'},
  {value: 'license', label: 'License'},
  {value: 'certificate', label: 'Certificate'},
  {value: 'diploma', label: 'Diploma'},
  {value: 'degree', label: 'Degree'},
];

export const credentialTypeOptionsSpain = [
  {value: 'membership', label: 'Afiliación'},
  {value: 'license', label: 'Licencia'},
  {value: 'certificate', label: 'Certificado'},
  {value: 'degree', label: 'Título'},
  {value: 'diploma', label: 'Diploma'},
];
export const credentialTypeOptionsPtBr = [
  {value: 'membership', label: 'Associação'},
  {value: 'license', label: 'Licença'},
  {value: 'certificate', label: 'Certificado'},
  {value: 'diploma', label: 'Diploma'},
  {value: 'degree', label: 'Grau Acadêmico'},
];

export const credentialTypeOptionsByCountry = {
  US: credentialTypeOptionsUs,
  ES: credentialTypeOptionsSpain,
  MX: credentialTypeOptionsSpain,
  PT: credentialTypeOptionsSpain,
  BR: credentialTypeOptionsPtBr,
};

export const conditionsOptionsUs = [
  {label: 'Addiction/Substance Abuse', value: 'Addiction/Substance Abuse'},
  {
    label: 'ADHD (Attention-Deficit/Hyperactivity Disorder)',
    value: 'ADHD (Attention-Deficit/Hyperactivity Disorder)',
  },
  {label: 'Anger Management', value: 'Anger Management'},
  {label: 'Anxiety', value: 'Anxiety'},
  {label: 'Eating Disorders', value: 'Eating Disorders'},
  {label: 'Family Issues', value: 'Family Issues'},
  {label: 'Grief (Loss)', value: 'Grief (Loss)'},
  {
    label: 'PTSD (Post-Traumatic Stress Disorder)',
    value: 'PTSD (Post-Traumatic Stress Disorder)',
  },
  {label: 'Stress Management', value: 'Stress Management'},
  {label: 'Bipolar Disorder', value: 'Bipolar Disorder'},
  {label: 'Sleep Disorders', value: 'Sleep Disorders'},
  {label: 'Friend Issues', value: 'Friend Issues'},
  {
    label: 'OCD (Obsessive-Compulsive Disorder)',
    value: 'OCD (Obsessive-Compulsive Disorder)',
  },
  {
    label: 'Professional (Career Issues)',
    value: 'Professional (Career Issues)',
  },
  {label: 'Depression', value: 'Depression'},
  {label: 'LGBTQ Identity', value: 'LGBTQ Identity'},
  {label: 'Romantic Partner Issues', value: 'Romantic Partner Issues'},
  {
    label: 'Others (please let us know in your bio)',
    value: 'Others (please let us know in your bio)',
  },
  {
    label: 'Perinatal Mental Health (Pregnancy, Postpartum, Parenting)',
    value: 'Perinatal Mental Health (Pregnancy, Postpartum, Parenting)',
  },
  {label: 'Adolescent Issues', value: 'Adolescent Issues'},
  {label: 'Adjustment Disorder', value: 'Adjustment Disorder'},
  {label: 'Domestic Violence Victims', value: 'Domestic Violence Victims'},
  {
    label: 'Domestic Violence offenders',
    value: 'Domestic Violence offenders',
  },
  {label: 'Self-esteem', value: 'Self-esteem'},
  {label: 'Multicultural', value: 'Multicultural'},
  {label: 'Personality Disorder', value: 'Personality Disorder'},
  {label: 'Identity Issues', value: 'Identity Issues'},
  {label: 'Faith Issues', value: 'Faith Issues'},
  {label: 'Sleep', value: 'Sleep'},
  {label: 'Adoption', value: 'Adoption'},
  {label: 'Divorce Recovery', value: 'Divorce Recovery'},
  {label: 'Homelessness', value: 'Homelessness'},
  {label: 'Group Therapy', value: 'Group Therapy'},
];

export const conditionsOptionsSpain = [
  {
    label: 'Adicción/Abuso de Sustancias',
    value: 'Adicción/Abuso de Sustancias',
  },
  {
    label: 'TDAH (Trastorno por Déficit de Atención con Hiperactividad)',
    value: 'TDAH (Trastorno por Déficit de Atención con Hiperactividad)',
  },
  {label: 'Manejo de la Ira', value: 'Manejo de la Ira'},
  {label: 'Ansiedad', value: 'Ansiedad'},
  {label: 'Trastornos Alimentarios', value: 'Trastornos Alimentarios'},
  {label: 'Problemas Familiares', value: 'Problemas Familiares'},
  {label: 'Duelo (Pérdida)', value: 'Duelo (Pérdida)'},
  {
    label: 'TEPT (Trastorno de Estrés Postraumático)',
    value: 'TEPT (Trastorno de Estrés Postraumático)',
  },
  {label: 'Manejo del Estrés', value: 'Manejo del Estrés'},
  {label: 'Trastorno Bipolar', value: 'Trastorno Bipolar'},
  {label: 'Trastornos del Sueño', value: 'Trastornos del Sueño'},
  {label: 'Problemas con Amigos', value: 'Problemas con Amigos'},
  {
    label: 'TOC (Trastorno Obsesivo-Compulsivo)',
    value: 'TOC (Trastorno Obsesivo-Compulsivo)',
  },
  {
    label: 'Problemas Profesionales (Carrera)',
    value: 'Problemas Profesionales (Carrera)',
  },
  {label: 'Depresión', value: 'Depresión'},
  {label: 'Identidad LGBTQ', value: 'Identidad LGBTQ'},
  {
    label: 'Problemas con la Pareja Romántica',
    value: 'Problemas con la Pareja Romántica',
  },
  {
    label: 'Otros (por favor infórmenos en su biografía)',
    value: 'Otros (por favor infórmenos en su biografía)',
  },
  {
    label: 'Salud Mental Perinatal (Embarazo, Postparto, Crianza)',
    value: 'Salud Mental Perinatal (Embarazo, Postparto, Crianza)',
  },
  {
    label: 'Problemas de la Adolescencia',
    value: 'Problemas de la Adolescencia',
  },
  {label: 'Trastorno de Adaptación', value: 'Trastorno de Adaptación'},
  {
    label: 'Víctimas de Violencia Doméstica',
    value: 'Víctimas de Violencia Doméstica',
  },
  {
    label: 'Agresores de Violencia Doméstica',
    value: 'Agresores de Violencia Doméstica',
  },
  {label: 'Autoestima', value: 'Autoestima'},
  {label: 'Multicultural', value: 'Multicultural'},
  {
    label: 'Trastorno de la Personalidad',
    value: 'Trastorno de la Personalidad',
  },
  {label: 'Problemas de Identidad', value: 'Problemas de Identidad'},
  {label: 'Problemas de Fe', value: 'Problemas de Fe'},
  {label: 'Sueño', value: 'Sueño'},
  {label: 'Adopción', value: 'Adopción'},
  {label: 'Recuperación del Divorcio', value: 'Recuperación del Divorcio'},
  {label: 'Desamparo', value: 'Desamparo'},
  {label: 'Terapia de Grupo', value: 'Terapia de Grupo'},
];

export const conditionsOptionsPortugal = [
  {
    label: 'Dependência/Abuso de Substâncias',
    value: 'Dependência/Abuso de Substâncias',
  },
  {
    label: 'TDAH (Transtorno de Déficit de Atenção com Hiperatividade)',
    value: 'TDAH (Transtorno de Déficit de Atenção com Hiperatividade)',
  },
  {label: 'Controle da Raiva', value: 'Controle da Raiva'},
  {label: 'Ansiedade', value: 'Ansiedade'},
  {label: 'Transtornos Alimentares', value: 'Transtornos Alimentares'},
  {label: 'Problemas Familiares', value: 'Problemas Familiares'},
  {label: 'Luto (Perda)', value: 'Luto (Perda)'},
  {
    label: 'TEPT (Transtorno de Estresse Pós-Traumático)',
    value: 'TEPT (Transtorno de Estresse Pós-Traumático)',
  },
  {label: 'Gestão do Estresse', value: 'Gestão do Estresse'},
  {label: 'Transtorno Bipolar', value: 'Transtorno Bipolar'},
  {label: 'Transtornos do Sono', value: 'Transtornos do Sono'},
  {label: 'Problemas com Amigos', value: 'Problemas com Amigos'},
  {
    label: 'TOC (Transtorno Obsessivo-Compulsivo)',
    value: 'TOC (Transtorno Obsessivo-Compulsivo)',
  },
  {
    label: 'Problemas Profissionais (Carreira)',
    value: 'Problemas Profissionais (Carreira)',
  },
  {label: 'Depressão', value: 'Depressão'},
  {label: 'Identidade LGBTQ', value: 'Identidade LGBTQ'},
  {
    label: 'Problemas com Parceiro(a) Romântico(a)',
    value: 'Problemas com Parceiro(a) Romântico(a)',
  },
  {
    label: 'Outros (por favor informe em sua biografia)',
    value: 'Outros (por favor informe em sua biografia)',
  },
  {
    label: 'Saúde Mental Perinatal (Gravidez, Pós-parto, Criação de Filhos)',
    value: 'Saúde Mental Perinatal (Gravidez, Pós-parto, Criação de Filhos)',
  },
  {label: 'Problemas na Adolescência', value: 'Problemas na Adolescência'},
  {label: 'Transtorno de Adaptação', value: 'Transtorno de Adaptação'},
  {
    label: 'Vítimas de Violência Doméstica',
    value: 'Vítimas de Violência Doméstica',
  },
  {
    label: 'Agressores de Violência Doméstica',
    value: 'Agressores de Violência Doméstica',
  },
  {label: 'Autoestima', value: 'Autoestima'},
  {label: 'Multicultural', value: 'Multicultural'},
  {
    label: 'Transtorno de Personalidade',
    value: 'Transtorno de Personalidade',
  },
  {label: 'Problemas de Identidade', value: 'Problemas de Identidade'},
  {label: 'Questões de Fé', value: 'Questões de Fé'},
  {label: 'Sono', value: 'Sono'},
  {label: 'Adoção', value: 'Adoção'},
  {label: 'Recuperação de Divórcio', value: 'Recuperação de Divórcio'},
  {label: 'Desamparo', value: 'Desamparo'},
  {label: 'Terapia de Grupo', value: 'Terapia de Grupo'},
];

export const conditionsOptionsByCountry = {
  US: conditionsOptionsUs,
  ES: conditionsOptionsSpain,
  MX: conditionsOptionsSpain,
  PT: conditionsOptionsPortugal,
  BR: conditionsOptionsPortugal,
};

export const therapyTypesOptionsUs = [
  {
    label: 'Acceptance and Commitment (ACT)',
    value: 'Acceptance and Commitment (ACT)',
  },
  {
    label: 'Applied Behavioral Analysis',
    value: 'Applied Behavioral Analysis',
  },
  {label: 'Biofeedback', value: 'Biofeedback'},
  {
    label: 'Clinical Supervision and Licensed Supervisors',
    value: 'Clinical Supervision and Licensed Supervisors',
  },
  {label: 'Cognitive Processing (CPT)', value: 'Cognitive Processing (CPT)'},
  {label: 'Dance Movement Therapy', value: 'Dance Movement Therapy'},
  {
    label: 'Eye Movement Desensitization and Reprocessing (EMDR)',
    value: 'Eye Movement Desensitization and Reprocessing (EMDR)',
  },
  {label: 'Existential', value: 'Existential'},
  {label: 'Expressive Arts', value: 'Expressive Arts'},
  {label: 'Feminist', value: 'Feminist'},
  {label: 'Gottman Method', value: 'Gottman Method'},
  {label: 'Imago', value: 'Imago'},
  {label: 'Interpersonal', value: 'Interpersonal'},
  {label: 'Mindfulness-Based (MBCT)', value: 'Mindfulness-Based (MBCT)'},
  {label: 'Music Therapy', value: 'Music Therapy'},
  {label: 'Neurofeedback', value: 'Neurofeedback'},
  {label: 'Positive Psychology', value: 'Positive Psychology'},
  {
    label: 'Psychobiological Approach Couple',
    value: 'Psychobiological Approach Couple',
  },
  {
    label: 'Rational Emotive Behavior (REBT)',
    value: 'Rational Emotive Behavior (REBT)',
  },
  {label: 'Structural Family Therapy', value: 'Structural Family Therapy'},
  {label: 'Regression Therapy', value: 'Regression Therapy'},
  {label: 'Adlerian', value: 'Adlerian'},
  {label: 'Art Therapy', value: 'Art Therapy'},
  {label: 'Brainspotting', value: 'Brainspotting'},
  {label: 'Coaching', value: 'Coaching'},
  {label: 'Compassion Focused', value: 'Compassion Focused'},
  {label: 'Dialectical (DBT)', value: 'Dialectical (DBT)'},
  {label: 'Emotionally Focused', value: 'Emotionally Focused'},
  {label: 'Experiential Therapy', value: 'Experiential Therapy'},
  {label: 'Family/Marital', value: 'Family/Marital'},
  {label: 'Forensic Psychology', value: 'Forensic Psychology'},
  {label: 'Humanistic', value: 'Humanistic'},
  {label: 'Integrative', value: 'Integrative'},
  {label: 'Intervention', value: 'Intervention'},
  {label: 'Motivational Interviewing', value: 'Motivational Interviewing'},
  {label: 'Narrative', value: 'Narrative'},
  {
    label: 'Parent-Child Interaction (PCIT)',
    value: 'Parent-Child Interaction (PCIT)',
  },
  {label: 'Prolonged Exposure Therapy', value: 'Prolonged Exposure Therapy'},
  {label: 'Psychodynamic', value: 'Psychodynamic'},
  {label: 'Reality Therapy', value: 'Reality Therapy'},
  {label: 'Transpersonal', value: 'Transpersonal'},
  {
    label: 'Other (please add to the bio)',
    value: 'Other (please add to the bio)',
  },
  {
    label: 'Accelerated Experiential Dynamic Psychotherapy (AEDP)',
    value: 'Accelerated Experiential Dynamic Psychotherapy (AEDP)',
  },
  {label: 'Attachment-based', value: 'Attachment-based'},
  {label: 'Christian Counseling', value: 'Christian Counseling'},
  {
    label: 'Cognitive Behavioral Therapy (CBT)',
    value: 'Cognitive Behavioral Therapy (CBT)',
  },
  {label: 'Culturally Sensitive', value: 'Culturally Sensitive'},
  {label: 'Eclectic', value: 'Eclectic'},
  {label: 'Energy Psychology', value: 'Energy Psychology'},
  {
    label: 'Exposure Response Prevention',
    value: 'Exposure Response Prevention',
  },
  {label: 'Family Systems', value: 'Family Systems'},
  {label: 'Gestalt', value: 'Gestalt'},
  {label: 'Hypnotherapy', value: 'Hypnotherapy'},
  {
    label: 'Internal Family Systems (IFS)',
    value: 'Internal Family Systems (IFS)',
  },
  {label: 'Jungian', value: 'Jungian'},
  {label: 'Multicultural', value: 'Multicultural'},
  {label: 'Neuro-Linguistic', value: 'Neuro-Linguistic'},
  {label: 'Person-Centered', value: 'Person-Centered'},
  {label: 'Psychoanalytic', value: 'Psychoanalytic'},
  {
    label: 'Psychological Testing and Evaluation',
    value: 'Psychological Testing and Evaluation',
  },
  {label: 'Schema Therapy', value: 'Schema Therapy'},
  {label: 'Trauma Focused', value: 'Trauma Focused'},
  {label: 'Strength-Based', value: 'Strength-Based'},
  {
    label: 'Solution Focused Brief (SFBT)',
    value: 'Solution Focused Brief (SFBT)',
  },
  {label: 'Somatic', value: 'Somatic'},
  {label: 'Sport Psychology', value: 'Sport Psychology'},
];

export const therapyTypesOptionsSpain = [
  {
    label: 'Terapia de Aceptación y Compromiso (ACT)',
    value: 'Terapia de Aceptación y Compromiso (ACT)',
  },
  {
    label: 'Análisis Conductual Aplicado',
    value: 'Análisis Conductual Aplicado',
  },
  {label: 'Biofeedback', value: 'Biofeedback'},
  {
    label: 'Supervisión Clínica y Supervisores Licenciados',
    value: 'Supervisión Clínica y Supervisores Licenciados',
  },
  {
    label: 'Procesamiento Cognitivo (CPT)',
    value: 'Procesamiento Cognitivo (CPT)',
  },
  {
    label: 'Terapia de Movimiento y Danza',
    value: 'Terapia de Movimiento y Danza',
  },
  {
    label:
      'Desensibilización y Reprocesamiento por Movimientos Oculares (EMDR)',
    value:
      'Desensibilización y Reprocesamiento por Movimientos Oculares (EMDR)',
  },
  {label: 'Existencial', value: 'Existencial'},
  {label: 'Artes Expresivas', value: 'Artes Expresivas'},
  {label: 'Feminista', value: 'Feminista'},
  {label: 'Método Gottman', value: 'Método Gottman'},
  {label: 'Imago', value: 'Imago'},
  {label: 'Interpersonal', value: 'Interpersonal'},
  {
    label: 'Basado en Mindfulness (MBCT)',
    value: 'Basado en Mindfulness (MBCT)',
  },
  {label: 'Terapia de Música', value: 'Terapia de Música'},
  {label: 'Neurofeedback', value: 'Neurofeedback'},
  {label: 'Psicología Positiva', value: 'Psicología Positiva'},
  {
    label: 'Enfoque Psicobiológico de Pareja',
    value: 'Enfoque Psicobiológico de Pareja',
  },
  {
    label: 'Terapia Racional Emotiva Conductual (REBT)',
    value: 'Terapia Racional Emotiva Conductual (REBT)',
  },
  {
    label: 'Terapia Familiar Estructural',
    value: 'Terapia Familiar Estructural',
  },
  {label: 'Terapia de Regresión', value: 'Terapia de Regresión'},
  {label: 'Adleriana', value: 'Adleriana'},
  {label: 'Terapia de Arte', value: 'Terapia de Arte'},
  {label: 'Brainspotting', value: 'Brainspotting'},
  {label: 'Coaching', value: 'Coaching'},
  {label: 'Compasión Enfocada', value: 'Compasión Enfocada'},
  {label: 'Terapia Dialéctica (DBT)', value: 'Terapia Dialéctica (DBT)'},
  {label: 'Enfoque Emocional', value: 'Enfoque Emocional'},
  {label: 'Terapia Experiencial', value: 'Terapia Experiencial'},
  {label: 'Familiar/Marital', value: 'Familiar/Marital'},
  {label: 'Psicología Forense', value: 'Psicología Forense'},
  {label: 'Humanista', value: 'Humanista'},
  {label: 'Integrativa', value: 'Integrativa'},
  {label: 'Intervención', value: 'Intervención'},
  {label: 'Entrevista Motivacional', value: 'Entrevista Motivacional'},
  {label: 'Narrativa', value: 'Narrativa'},
  {
    label: 'Interacción Padres-Hijos (PCIT)',
    value: 'Interacción Padres-Hijos (PCIT)',
  },
  {
    label: 'Terapia de Exposición Prolongada',
    value: 'Terapia de Exposición Prolongada',
  },
  {label: 'Psicodinámica', value: 'Psicodinámica'},
  {label: 'Terapia de la Realidad', value: 'Terapia de la Realidad'},
  {label: 'Transpersonal', value: 'Transpersonal'},
  {
    label: 'Otro (por favor agregar a la bio)',
    value: 'Otro (por favor agregar a la bio)',
  },
  {
    label: 'Terapia Dinámica Experiencial Acelerada (AEDP)',
    value: 'Terapia Dinámica Experiencial Acelerada (AEDP)',
  },
  {label: 'Basada en el Apego', value: 'Basada en el Apego'},
  {label: 'Consejería Cristiana', value: 'Consejería Cristiana'},
  {
    label: 'Terapia Cognitivo-Conductual (CBT)',
    value: 'Terapia Cognitivo-Conductual (CBT)',
  },
  {label: 'Sensibilidad Cultural', value: 'Sensibilidad Cultural'},
  {label: 'Ecléctica', value: 'Ecléctica'},
  {label: 'Psicología Energética', value: 'Psicología Energética'},
  {
    label: 'Prevención de Respuesta de Exposición',
    value: 'Prevención de Respuesta de Exposición',
  },
  {label: 'Sistemas Familiares', value: 'Sistemas Familiares'},
  {label: 'Gestalt', value: 'Gestalt'},
  {label: 'Hipnoterapia', value: 'Hipnoterapia'},
  {
    label: 'Sistemas Internos de Familia (IFS)',
    value: 'Sistemas Internos de Familia (IFS)',
  },
  {label: 'Jungiana', value: 'Jungiana'},
  {label: 'Multicultural', value: 'Multicultural'},
  {
    label: 'Programación Neuro-Lingüística',
    value: 'Programación Neuro-Lingüística',
  },
  {label: 'Centrada en la Persona', value: 'Centrada en la Persona'},
  {label: 'Psicoanalítica', value: 'Psicoanalítica'},
  {
    label: 'Evaluación y Pruebas Psicológicas',
    value: 'Evaluación y Pruebas Psicológicas',
  },
  {label: 'Terapia de Esquemas', value: 'Terapia de Esquemas'},
  {label: 'Enfocada en el Trauma', value: 'Enfocada en el Trauma'},
  {label: 'Basada en Fortalezas', value: 'Basada en Fortalezas'},
  {
    label: 'Terapia Breve Enfocada en Soluciones (SFBT)',
    value: 'Terapia Breve Enfocada en Soluciones (SFBT)',
  },
  {label: 'Somática', value: 'Somática'},
  {label: 'Psicología del Deporte', value: 'Psicología del Deporte'},
];
export const therapyTypesOptionsPt = [
  {
    label: 'Aceitação e Compromisso (ACT)',
    value: 'Aceitação e Compromisso (ACT)',
  },
  {
    label: 'Análise Comportamental Aplicada',
    value: 'Análise Comportamental Aplicada',
  },
  {label: 'Biofeedback', value: 'Biofeedback'},
  {
    label: 'Supervisão Clínica e Supervisores Licenciados',
    value: 'Supervisão Clínica e Supervisores Licenciados',
  },
  {
    label: 'Processamento Cognitivo (CPT)',
    value: 'Processamento Cognitivo (CPT)',
  },
  {
    label: 'Terapia de Movimento e Dança',
    value: 'Terapia de Movimento e Dança',
  },
  {
    label: 'Dessensibilização e Reprocessamento por Movimentos Oculares (EMDR)',
    value: 'Dessensibilização e Reprocessamento por Movimentos Oculares (EMDR)',
  },
  {label: 'Existencial', value: 'Existencial'},
  {label: 'Artes Expressivas', value: 'Artes Expressivas'},
  {label: 'Feminista', value: 'Feminista'},
  {label: 'Método Gottman', value: 'Método Gottman'},
  {label: 'Imago', value: 'Imago'},
  {label: 'Interpessoal', value: 'Interpessoal'},
  {
    label: 'Baseada em Mindfulness (MBCT)',
    value: 'Baseada em Mindfulness (MBCT)',
  },
  {label: 'Musicoterapia', value: 'Musicoterapia'},
  {label: 'Neurofeedback', value: 'Neurofeedback'},
  {label: 'Psicologia Positiva', value: 'Psicologia Positiva'},
  {
    label: 'Abordagem Psicobiológica para Casais',
    value: 'Abordagem Psicobiológica para Casais',
  },
  {
    label: 'Comportamento Racional Emotivo (REBT)',
    value: 'Comportamento Racional Emotivo (REBT)',
  },
  {label: 'Terapia Familiar Estrutural', value: 'Terapia Familiar Estrutural'},
  {label: 'Terapia de Regressão', value: 'Terapia de Regressão'},
  {label: 'Adleriana', value: 'Adleriana'},
  {label: 'Terapia Artística', value: 'Terapia Artística'},
  {label: 'Brainspotting', value: 'Brainspotting'},
  {label: 'Coaching', value: 'Coaching'},
  {label: 'Focada na Compaixão', value: 'Focada na Compaixão'},
  {label: 'Dialética (DBT)', value: 'Dialética (DBT)'},
  {label: 'Focada nas Emoções', value: 'Focada nas Emoções'},
  {label: 'Terapia Experiencial', value: 'Terapia Experiencial'},
  {label: 'Familiar/Conjugal', value: 'Familiar/Conjugal'},
  {label: 'Psicologia Forense', value: 'Psicologia Forense'},
  {label: 'Humanista', value: 'Humanista'},
  {label: 'Integrativa', value: 'Integrativa'},
  {label: 'Intervenção', value: 'Intervenção'},
  {label: 'Entrevista Motivacional', value: 'Entrevista Motivacional'},
  {label: 'Narrativa', value: 'Narrativa'},
  {label: 'Interação Pai-Filho (PCIT)', value: 'Interação Pai-Filho (PCIT)'},
  {
    label: 'Terapia de Exposição Prolongada',
    value: 'Terapia de Exposição Prolongada',
  },
  {label: 'Psicodinâmica', value: 'Psicodinâmica'},
  {label: 'Terapia da Realidade', value: 'Terapia da Realidade'},
  {label: 'Transpessoal', value: 'Transpessoal'},
  {
    label: 'Outro (por favor adicionar à bio)',
    value: 'Outro (por favor adicionar à bio)',
  },
  {
    label: 'Terapia Dinâmica Experiencial Acelerada (AEDP)',
    value: 'Terapia Dinâmica Experiencial Acelerada (AEDP)',
  },
  {label: 'Baseada em Apego', value: 'Baseada em Apego'},
  {label: 'Aconselhamento Cristão', value: 'Aconselhamento Cristão'},
  {
    label: 'Terapia Cognitivo-Comportamental (CBT)',
    value: 'Terapia Cognitivo-Comportamental (CBT)',
  },
  {label: 'Culturalmente Sensível', value: 'Culturalmente Sensível'},
  {label: 'Eclética', value: 'Eclética'},
  {label: 'Psicologia Energética', value: 'Psicologia Energética'},
  {
    label: 'Prevenção de Resposta à Exposição',
    value: 'Prevenção de Resposta à Exposição',
  },
  {label: 'Sistemas Familiares', value: 'Sistemas Familiares'},
  {label: 'Gestalt', value: 'Gestalt'},
  {label: 'Hipnoterapia', value: 'Hipnoterapia'},
  {
    label: 'Sistemas Internos Familiares (IFS)',
    value: 'Sistemas Internos Familiares (IFS)',
  },
  {label: 'Junguiana', value: 'Junguiana'},
  {label: 'Multicultural', value: 'Multicultural'},
  {label: 'Neuro-Linguística', value: 'Neuro-Linguística'},
  {label: 'Centrada na Pessoa', value: 'Centrada na Pessoa'},
  {label: 'Psicanalítica', value: 'Psicanalítica'},
  {
    label: 'Testes e Avaliações Psicológicas',
    value: 'Testes e Avaliações Psicológicas',
  },
  {label: 'Terapia de Esquemas', value: 'Terapia de Esquemas'},
  {label: 'Focada no Trauma', value: 'Focada no Trauma'},
  {label: 'Baseada em Forças', value: 'Baseada em Forças'},
  {label: 'Solução Breve Focada (SFBT)', value: 'Solução Breve Focada (SFBT)'},
  {label: 'Somática', value: 'Somática'},
  {label: 'Psicologia Esportiva', value: 'Psicologia Esportiva'},
];

export const therapyTypesOptionsByCountry = {
  US: therapyTypesOptionsUs,
  ES: therapyTypesOptionsSpain,
  MX: therapyTypesOptionsSpain,
  BR: therapyTypesOptionsPt,
};

export const ethnicityOptionsUs = [
  {label: 'African American', value: 'African American'},
  {label: 'African-Caribbean', value: 'African-Caribbean'},
  {label: 'Vietnamese American', value: 'Vietnamese American'},
  {label: 'Prefer not to say', value: 'Prefer not to say'},
  {label: 'Unsure', value: 'Unsure'},
  {label: 'White', value: 'White'},
  {label: 'Hispanic', value: 'Hispanic'},
  {label: 'Russian', value: 'Russian'},
  {label: 'English', value: 'English'},
  {label: 'German', value: 'German'},
  {label: 'Native American', value: 'Native American'},
  {label: 'Caucasian', value: 'Caucasian'},
  {label: 'South Asian', value: 'South Asian'},
  {label: 'European', value: 'European'},
  {label: 'Latina', value: 'Latina'},
];

export const ethnicityOptionsPt = [
  {label: 'Afro-Americano', value: 'Afro-Americano'},
  {label: 'Afro-Caribenho', value: 'Afro-Caribenho'},
  {label: 'Vietnamita Americano', value: 'Vietnamita Americano'},
  {label: 'Prefiro não dizer', value: 'Prefiro não dizer'},
  {label: 'Indeciso', value: 'Indeciso'},
  {label: 'Branco', value: 'Branco'},
  {label: 'Hispânico', value: 'Hispânico'},
  {label: 'Russo', value: 'Russo'},
  {label: 'Inglês', value: 'Inglês'},
  {label: 'Alemão', value: 'Alemão'},
  {label: 'Nativo Americano', value: 'Nativo Americano'},
  {label: 'Caucasiano', value: 'Caucasiano'},
  {label: 'Sul-Asiático', value: 'Sul-Asiático'},
  {label: 'Europeu', value: 'Europeu'},
  {label: 'Latina', value: 'Latina'},
];

export const ethnicityOptionsSpain = [
  {label: 'Afroamericano', value: 'Afroamericano'},
  {label: 'Afrocaribeño', value: 'Afrocaribeño'},
  {label: 'Vietnamita Americano', value: 'Vietnamita Americano'},
  {label: 'Prefiero no decirlo', value: 'Prefiero no decirlo'},
  {label: 'No estoy seguro', value: 'No estoy seguro'},
  {label: 'Blanco', value: 'Blanco'},
  {label: 'Hispano', value: 'Hispano'},
  {label: 'Ruso', value: 'Ruso'},
  {label: 'Inglés', value: 'Inglés'},
  {label: 'Alemán', value: 'Alemán'},
  {label: 'Nativo Americano', value: 'Nativo Americano'},
  {label: 'Caucásico', value: 'Caucásico'},
  {label: 'Sudasiático', value: 'Sudasiático'},
  {label: 'Europeo', value: 'Europeo'},
  {label: 'Latino', value: 'Latino'},
];

export const ethnicityOptionsByCountry = {
  US: ethnicityOptionsUs,
  ES: ethnicityOptionsSpain,
  MX: ethnicityOptionsSpain,
  BR: ethnicityOptionsPt,
};

export const languageOptionsUs = [
  {label: 'English', value: 'English'},
  {label: 'Spanish', value: 'Spanish'},
  {label: 'Arabic', value: 'Arabic'},
  {label: 'Romanian', value: 'Romanian'},
  {label: 'Vietnamese', value: 'Vietnamese'},
  {label: 'Chinese', value: 'Chinese'},
  {label: 'Filipino', value: 'Filipino'},
  {
    label: 'Understands Caribbean Dialect',
    value: 'Understands Caribbean Dialect',
  },
  {label: 'Russian', value: 'Russian'},
  {label: 'Urdu', value: 'Urdu'},
  {label: 'Hindi', value: 'Hindi'},
  {label: 'Portuguese', value: 'Portuguese'},
  {label: 'Haitian Creole', value: 'Haitian Creole'},
  {label: 'Hmong', value: 'Hmong'},
];

export const languageOptionsSpain = [
  {label: 'Inglés', value: 'Inglés'},
  {label: 'Español', value: 'Español'},
  {label: 'Árabe', value: 'Árabe'},
  {label: 'Rumano', value: 'Rumano'},
  {label: 'Vietnamita', value: 'Vietnamita'},
  {label: 'Chino', value: 'Chino'},
  {label: 'Filipino', value: 'Filipino'},
  {
    label: 'Entiende el dialecto caribeño',
    value: 'Entiende el dialecto caribeño',
  },
  {label: 'Ruso', value: 'Ruso'},
  {label: 'Urdu', value: 'Urdu'},
  {label: 'Hindi', value: 'Hindi'},
  {label: 'Portugués', value: 'Portugués'},
  {label: 'Criollo Haitiano', value: 'Criollo Haitiano'},
  {label: 'Hmong', value: 'Hmong'},
];

export const languageOptionsPortugal = [
  {label: 'Inglês', value: 'Inglês'},
  {label: 'Espanhol', value: 'Espanhol'},
  {label: 'Árabe', value: 'Árabe'},
  {label: 'Romeno', value: 'Romeno'},
  {label: 'Vietnamita', value: 'Vietnamita'},
  {label: 'Chinês', value: 'Chinês'},
  {label: 'Filipino', value: 'Filipino'},
  {
    label: 'Compreende o Dialeto Caribenho',
    value: 'Compreende o Dialeto Caribenho',
  },
  {label: 'Russo', value: 'Russo'},
  {label: 'Urdu', value: 'Urdu'},
  {label: 'Hindi', value: 'Hindi'},
  {label: 'Português', value: 'Português'},
  {label: 'Crioulo Haitiano', value: 'Crioulo Haitiano'},
  {label: 'Hmong', value: 'Hmong'},
];

export const languageOptionsByCountry = {
  US: languageOptionsUs,
  ES: languageOptionsSpain,
  MX: languageOptionsSpain,
  PT: languageOptionsPortugal,
  BR: languageOptionsPortugal,
};

export const pronounOptionsUs = [
  {label: 'Select Pronouns', value: null},
  {label: 'He/Him/His', value: 'He/Him/His'},
  {label: 'She/Her/Hers', value: 'She/Her/Hers'},
  {label: 'They/Them/Theirs', value: 'They/Them/Theirs'},
  {label: 'Ze/Zir/Zirs', value: 'Ze/Zir/Zirs'},
  {label: 'Xe/Xem/Xyr', value: 'Xe/Xem/Xyr'},
];

export const pronounOptionsSpain = [
  {label: 'Seleccionar Pronombres', value: null},
  {label: 'Él', value: 'Él'},
  {label: 'Ella', value: 'Ella'},
  {label: 'Elle', value: 'Elle'},
  {label: 'Ze/Zir/Zirs', value: 'Ze/Zir/Zirs'}, // This pronoun set doesn't have a Spanish equivalent.
  {label: 'Xe/Xem/Xyr', value: 'Xe/Xem/Xyr'}, // This pronoun set doesn't have a Spanish equivalent.
];

export const pronounOptionsPortugal = [
  {label: 'Selecione Pronomes', value: null},
  {label: 'Ele/Dele', value: 'Ele/Dele'},
  {label: 'Ela/Dela', value: 'Ela/Dela'},
  {label: 'Elu/Delu', value: 'Elu/Delu'},
  {label: 'Ze/Zir/Zirs', value: 'Ze/Zir/Zirs'}, // This pronoun set doesn't have a Portuguese equivalent.
  {label: 'Xe/Xem/Xyr', value: 'Xe/Xem/Xyr'}, // This pronoun set doesn't have a Portuguese equivalent.
];

export const pronounOptionsByCountry = {
  US: pronounOptionsUs,
  ES: pronounOptionsSpain,
  MX: pronounOptionsSpain,
  PT: pronounOptionsPortugal,
  BR: pronounOptionsPortugal,
};
